// extracted by mini-css-extract-plugin
module.exports = {"link_desc":"FJLinkPrompt_link_desc__15rAS","word":"FJLinkPrompt_word__1EEpk"};